import { render, staticRenderFns } from "./businessDetailGroupOrder.vue?vue&type=template&id=70e33afa&scoped=true"
import script from "./businessDetailGroupOrder.vue?vue&type=script&lang=js"
export * from "./businessDetailGroupOrder.vue?vue&type=script&lang=js"
import style0 from "./businessDetailGroupOrder.vue?vue&type=style&index=0&id=70e33afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e33afa",
  null
  
)

export default component.exports